import { WorkflowRuleConditionLabel } from "@/components/Molecules/WorkflowRuleConditionLabel/WorkflowRuleConditionLabel";
import type { AppTranslateFn } from "@/hooks/use-app-translation";
import type { RuleOverviewParts } from "@/utils/workflow-rules/format";

interface WorkflowRuleOverviewProps {
	parts: RuleOverviewParts;
	t: AppTranslateFn;
}

/**
 * Monospace rule overview with readable condition field names and ID tooltips.
 */
export function WorkflowRuleOverview({ parts, t }: WorkflowRuleOverviewProps) {
	const andLabel = t("admin.workflowRules.drawer.summary.and");
	const ifLabel = t("admin.workflowRules.drawer.summary.if");

	return (
		<div className="whitespace-pre-wrap font-mono text-sm text-gray-800">
			<div>{parts.whenLine}</div>
			{parts.conditions.length > 0 ? (
				<div>
					{ifLabel}:{" "}
					{parts.conditions.map((cond, i) => (
						<span key={cond.fieldId ?? `${cond.fieldLabel}-${i}`}>
							{i > 0 ? ` ${andLabel} ` : null}
							<WorkflowRuleConditionLabel parts={cond} mono />
						</span>
					))}
				</div>
			) : null}
			{parts.thenLine ? <div>{parts.thenLine}</div> : null}
		</div>
	);
}
